// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__UF9Jv","plus":"styles_plus__GcGSp","key":"styles_key__iJZ6l"};